import MetaTags from "react-meta-tags";
import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
} from "reactstrap";

import toastr from "toastr"

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

import { withRouter } from "react-router-dom";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";

import avatar from "../../assets/images/users/avatar-1.jpg";
// actions
import { editProfile, resetProfileFlag } from "../../store/auth/profile/actions";
import { changePasswordAdmin as onChangePasswordAdmin,} from "../../store/admin/actions"

import { messageTitle } from "constants/common";

import { retrieveValues } from "../../helpers/storagewrapper.js"
import { passwordRegex } from "../../helpers/validator"

const UserProfile = props => {
  const dispatch = useDispatch();

  const [email, setemail] = useState("");
  const [name, setname] = useState("");
  const [idx, setidx] = useState(1);
  const [objectId, setObjectId] = useState("");

  // const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);

  const { error, success, message } = useSelector(state => ({
    error: state.Profile.error,
    success: state.Profile.success,
    message: state.admins.message,
  }));

  useEffect(() => {
    if (message) {
      toastr.success(message, messageTitle)
    }
  }, [message])

  useEffect(() => {
    if (retrieveValues("authUser")) {
      const obj = JSON.parse(retrieveValues("authUser"));
      if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
        setname(obj.displayName);
        setemail(obj.email);
        setidx(obj.uid);
      } else if (
        process.env.REACT_APP_DEFAULTAUTH === "fake" ||
        process.env.REACT_APP_DEFAULTAUTH === "jwt"
      ) {
        setname(obj.data.name);
        setemail(obj.data.email);
        setidx(obj.data.adminId);
        setObjectId(obj.data._id)
      }
      setTimeout(() => {
        dispatch(resetProfileFlag());
      }, 3000);
    }
  }, [dispatch, success]);

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      username: name || '',
      idx : idx || '',
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Please Enter Your UserName"),
    }),
    onSubmit: (values) => {
      dispatch(editProfile(values));
    }
  });

  
  // Password toggle handler
  const togglePassword = () => {
    // inverse the boolean state of passwordShown
    setPasswordShown(!passwordShown);
  };

  const passwordValidation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      // currentPassword: currentPassword || '',
      newPassword: newPassword || '',
      confirmPassword : confirmPassword || '',
    },
    validationSchema: Yup.object({
      // currentPassword: Yup.string()
      //   .required("Please Enter Current Password"),
      newPassword: Yup.string()
        .required("Please Enter New Password")
        .min(Number(process.env.REACT_APP_PASSWORD_MIN_LENGTH), "Must be at least "+process.env.REACT_APP_PASSWORD_MIN_LENGTH+" characters") 
        .matches(passwordRegex,
         "Password must contain at least "+process.env.REACT_APP_PASSWORD_MIN_LENGTH+" characters, one uppercase, one number and one special case character"
        ),
      confirmPassword: Yup.string()
        .required("Please Enter New Password")
        .min(Number(process.env.REACT_APP_PASSWORD_MIN_LENGTH), "Must be at least "+process.env.REACT_APP_PASSWORD_MIN_LENGTH+" characters")
        .oneOf([Yup.ref('newPassword'), null], "Passwords do not match"),
    }),
    onSubmit: (values) => {
      setNewPassword(values.newPassword);
      setConfirmPassword(values.confirmPassword);
      if (objectId === "") {
        toastr.error("Something went wrong", "") // No object Id
      } else if (values.newPassword !== values.confirmPassword) {
        toastr.error("Passwords do not match", "") // should not trigger
      }

      const payload = {
        id: objectId,
        email: email,
        password: values.newPassword,
      }
      dispatch(onChangePasswordAdmin(payload))
    }
  });


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Profile | Skote - React Admin & Dashboard Template</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="Skote" breadcrumbItem="Profile" />

          <Row>
            <Col lg="6">
              {error && error ? <Alert color="danger">{error}</Alert> : null}
              {success ? <Alert color="success">{success}</Alert> : null}

              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="me-1">
                      <img
                        src={avatar}
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <h5>{name}</h5>
                        <p className="mb-1">{email}</p>
                        <p className="mb-0">Id no: #{idx}</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <h4 className="card-title mb-4 w-50 mx-auto">Change User Name</h4>

          <Card>
            <CardBody>
              <Form
                className="form-horizontal"
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <div className="form-group w-50 mx-auto">
                  
                  <h5 className="card-title w-50 mx-auto">User Name</h5>
                  <Input
                    name="username"
                    // value={name}
                    className="form-control w-50 mx-auto"
                    placeholder="Enter User Name"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.username || ""}
                    invalid={
                      validation.touched.username && validation.errors.username ? true : false
                    }
                  />
                  {validation.touched.username && validation.errors.username ? (
                    <FormFeedback type="invalid">{validation.errors.username}</FormFeedback>
                  ) : null}
                  <Input name="idx" value={idx} type="hidden" />
                </div>
                <div className="text-center mt-4 w-50  mx-auto">
                  <Button type="submit" color="danger">
                    Update User Name
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>


          {/* Change Password section */}
          <div className="d-flex justify-content-between w-50  mx-auto">
            <h4 className="card-title mb-4">Change Password</h4>
            {/* <Button size="sm" onClick={togglePassword}>Show Passwords</Button> */}
          </div>

          <Card>
            <CardBody>
              <Form
                className="form-horizontal w-50  mx-auto"
                onSubmit={(e) => {
                  e.preventDefault();
                  passwordValidation.handleSubmit();
                  return false;
                }}
              >
                {/* <div className="form-group">
                  <Label className="form-label md-6">Current Password</Label>
                  <Input
                    name="currentPassword"
                    // value={name}
                    className="form-control"
                    placeholder="Enter Current Password"
                    type={passwordShown ? "text" : "password"}
                    onChange={passwordValidation.handleChange}
                    onBlur={passwordValidation.handleBlur}
                    value={passwordValidation.values.currentPassword || ""}
                    invalid={
                      passwordValidation.touched.currentPassword && passwordValidation.errors.currentPassword ? true : false
                    }
                  />
                  {passwordValidation.touched.currentPassword && passwordValidation.errors.currentPassword ? (
                    <FormFeedback type="invalid">{passwordValidation.errors.currentPassword}</FormFeedback>
                  ) : null}
                </div> */}

                <div className="form-group w-50  mx-auto">
                  <Label className="form-label">New Password</Label>
                  <Input
                    name="newPassword"
                    className="form-control"
                    placeholder="Enter New Password"
                    type={passwordShown ? "text" : "password"}
                    onChange={passwordValidation.handleChange}
                    onBlur={passwordValidation.handleBlur}
                    value={passwordValidation.values.newPassword || ""}
                    invalid={
                      passwordValidation.touched.newPassword && passwordValidation.errors.newPassword ? true : false
                    }
                  />
                  {passwordValidation.touched.newPassword && passwordValidation.errors.newPassword ? (
                    <FormFeedback type="invalid">{passwordValidation.errors.newPassword}</FormFeedback>
                  ) : null}
                </div>

                <div className="form-group w-50  mx-auto">
                  <Label className="form-label w-50">Confirm Password</Label>
                  <Input
                    name="confirmPassword"
                    className="form-control"
                    placeholder="Confirm Password"
                    type={passwordShown ? "text" : "password"}
                    onChange={passwordValidation.handleChange}
                    onBlur={passwordValidation.handleBlur}
                    value={passwordValidation.values.confirmPassword || ""}
                    invalid={
                      passwordValidation.touched.confirmPassword && passwordValidation.errors.confirmPassword ? true : false
                    }
                  />
                  {passwordValidation.touched.confirmPassword && passwordValidation.errors.confirmPassword ? (
                    <FormFeedback type="invalid">{passwordValidation.errors.confirmPassword}</FormFeedback>
                  ) : null}
                </div>
                <div className="text-center mt-4">
                  <Button 
                    type="submit" 
                    color={(passwordValidation.errors.newPassword || passwordValidation.errors.confirmPassword) ? "secondary" : "danger"} 
                    disabled={(passwordValidation.errors.newPassword || passwordValidation.errors.confirmPassword) ? true : false}
                  >
                    Change Password
                  </Button>
                </div>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(UserProfile);
